;(function(){
	require ('bootstrap/dist/js/bootstrap');
	var sliderLists;

	var MOBILE_RESOLUTION = 768;

	function onSlideControlClick(e) {
		var countSlides;
		var currentSlideNo = 0;
		var slides;
		var i;
		var listId;

		slides = e.relatedTarget.closest('.carousel-inner').getElementsByClassName('item');
		slides = Array.prototype.slice.call(slides);
		countSlides = slides.length;
		for (i = 0; i < countSlides; i++) {
			if (slides[i] == e.relatedTarget) {
				currentSlideNo = ++i;
				break;
			}
		}

		e.relatedTarget.closest('.carousel').querySelector('.carousel-numeric__slide-no').innerHTML =
			currentSlideNo + ' / ' + countSlides;

		listId = e.relatedTarget.closest('.carousel').dataset.listId;
		if (listId) {
			document.getElementById(listId).querySelector('.menu-vertical1__link_active')
				.classList.remove('menu-vertical1__link_active');
			document.getElementById(listId).querySelectorAll('.menu-vertical1__link')[currentSlideNo-1]
				.classList.add('menu-vertical1__link_active');
		}
		if (document.documentElement.clientWidth < MOBILE_RESOLUTION) {
			var scrollable = $(this).closest('.fp-scrollable');
			var iScrollInstance = scrollable.data('iscrollInstance');
			setTimeout(function(){
				iScrollInstance.scrollToElement(e.relatedTarget,1000,0,0,{
					style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
					fn: function (k) {
						return k * ( 2 - k );
					}
				});
			},300)
		}

	}

	function slide(e) {
		var list;
		var selectedIndex;
		e = e || event;
		if (!e.target.closest('.menu-vertical1__link')) {
			return;
		}
		e.target.closest('.menu-vertical1').querySelector('.menu-vertical1__link_active')
			.classList.remove('menu-vertical1__link_active');

		e.target.closest('.menu-vertical1__link')
			.classList.add('menu-vertical1__link_active');

		list = e.target.closest('.menu-vertical1')
			.querySelectorAll('.menu-vertical1__link');
		list = Array.prototype.slice.call(list);
		selectedIndex = list.indexOf(e.target.closest('.menu-vertical1__link'));
		$('#' + e.target.closest('.menu-vertical1').dataset.carouselId)
			.carousel(selectedIndex);
		$('#' + e.target.closest('.menu-vertical1').dataset.carouselId)
			.carousel("pause");

		e.preventDefault();

	}


	sliderLists = document.querySelectorAll('.menu-vertical1');
	sliderLists = Array.prototype.slice.call(sliderLists);
	sliderLists.forEach(function(sliderList) {
		if (sliderList.dataset.carouselId) {
			sliderList.addEventListener('click',slide);
		}
	})




    $('#carousel1').bind('slide.bs.carousel', onSlideControlClick);
    $('#carousel2').bind('slide.bs.carousel', onSlideControlClick);
    $('#carousel3').bind('slide.bs.carousel', onSlideControlClick);

})();



//////////////////
// WEBPACK FOOTER
// ./frontend/js/carousel-numeric.js
// module id = 2
// module chunks = 0